import React, {Component} from 'react';
import { connect } from 'react-redux';
import { fetchClientProducts} from '../../actions/client/clientProducts';
import ProductOptions from './ProductOptions';
import { literals } from '../../languages';

class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeProductPanel: null,
      productCount: 0
    };
  }

  toggleProductsPanel = () => {
    this.props.callbackToggleProductsPanel(this.props.item['@id']);
    this.props.fetchClientProducts(this.props.item['@id']);
    this.setState({
      panelIsOpen: false,
      activeProductPanel: null
    });
  }

  /*
    Add to state the selected id (activeProductPanel)
    when user click to the same tab(var productCount) then close the panel.
  */
  setActiveProductPanel = (id) => {
    let panelIsOpen;
    let productCount = this.state.productCount;

    if(this.state.activeProductPanel) {
      if (this.state.activeProductPanel !== id) {
        panelIsOpen = true;
        productCount = 0;
      } else {
        panelIsOpen = false;
        productCount++;
        if (productCount > 1) {
          panelIsOpen = true;
          productCount = 0;
        }
      }
    } else {
      panelIsOpen = true;
      productCount = 0;
    }

    this.setState({
      activeProductPanel: this.state.activeProductPanel !== id ? id : null,
      panelIsOpen,
      productCount
    });
  }

  renderProducts = () => {
    let clientProducts = this.props.data['hydra:member'];
    // if (this.props.loading) return  <CircularProgress style={{color:'teal'}} size={40} thickness={6} />
    if (this.props.loading) return <div className='timeline-item'><div className="animated-background"></div><div className="animated-background"></div><div className="animated-background"></div></div>

    if (clientProducts && !clientProducts.length) return <div>{literals.noProductsMessage[this.props.locale]}</div>

    return (
      clientProducts && clientProducts.map( (p,i) =>
        <div onClick={(id) => {this.setActiveProductPanel(p['@id'])}} className={"products-list__item " + (this.state.activeProductPanel === p['@id'] ? "products-list__item--active" : '')} key={`clientProductId-${p['@id']}-${i}`}>{p.product['name']}</div>
      )
    );
  }

  render() {
    let item = this.props.item;
    const isOpen = this.props.id === this.props.activeProductPanelId;
    return (
      <div className={"client-list__item " + (isOpen ? 'client-list__item--open' : '') }>
        <div className={"status-dot " + ( this.props.item.isEnabled ? "status-dot--enabled" : "") }></div>
        <div onClick={this.toggleProductsPanel} className="name">{item['name']}</div>
        <div>{item['domainName']} </div>
        <div className="action-cell">
          <div onClick={(clientId)=>{this.props.toggleClientEditForm(item['@id'])}} className="action-cell__btn action-cell__btn--edit">
            <span>{literals.editClient[this.props.locale]}</span>
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </div>
          <div onClick={this.toggleProductsPanel} className="show-products-btn action-cell__btn">
            <span>{literals.showProducts[this.props.locale]}</span>
            <i className="fa fa-caret-down" aria-hidden="true"></i>
          </div>
        </div>
        <section className={"products-list " + (isOpen ? 'products-list--open' : '') }>
        {this.renderProducts()}
        {isOpen && this.state.panelIsOpen && !this.props.loading && <ProductOptions locale={this.props.locale} clientId={this.props.item['@id'].split('/api/clients/').pop()} id={this.state.activeProductPanel} />}
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.client.clientProducts.data,
    error: state.client.clientProducts.error,
    loading: state.client.clientProducts.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchClientProducts: (id) => dispatch(fetchClientProducts(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListItem);



// WEBPACK FOOTER //
// ./src/components/client/ListItem.js